// extracted by mini-css-extract-plugin
export default {"calibration":"ResistanceChart_calibration__smTfK"};